import { FC } from 'react';

import { CompanyProfile } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';
import { useCompanyProfile } from 'common/hooks/useCompanyProfile';
import SunshineLoader from 'components/_core/SunshineLoader';

import EstimationSettings from './components/EstimationSettings';

const EstimationSettingsContainer: FC = () => {
  const { companyProfileId } = useCompanyContext();
  const { company, loading } = useCompanyProfile(companyProfileId);

  if (loading || !company) {
    return <SunshineLoader />;
  }

  return <EstimationSettings company={company as CompanyProfile} />;
};

export default EstimationSettingsContainer;
